import { render, staticRenderFns } from "./PlaylistVideoPlayer.vue?vue&type=template&id=46ff79b0&scoped=true"
import script from "./PlaylistVideoPlayer.vue?vue&type=script&lang=js"
export * from "./PlaylistVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./PlaylistVideoPlayer.vue?vue&type=style&index=0&id=46ff79b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ff79b0",
  null
  
)

export default component.exports